import { captureException } from '@sentry/react';
import { getConfigKey } from '@hiver/hiver-config-library';
import { ERROR_TYPES } from './SentryConstants';

export const sendExceptionToSentry = (err, extraTags = {}) => {
  const { NETWORK_ERROR, KNOWN_ERRORS, API_ERRORS } = ERROR_TYPES,
    errorMessage = err && err.message,
    shouldMute = [...NETWORK_ERROR, ...KNOWN_ERRORS, ...API_ERRORS].includes(errorMessage);
  if (shouldMute) return;
  captureException(err, {
    tags: {
      ...extraTags,
      email: getConfigKey('hiver-config.email')
    }
  });
}
